import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { ArrowUpRight, BookOpen } from "lucide-react";

const CAT_COLOR = {
  Jawline: "var(--primary)",
  Skin: "var(--success)",
  Hair: "var(--warning)",
  Body: "var(--primary)",
  Style: "#7af",
  Recovery: "#aaa",
  Mindset: "#fff",
};

export default function Guides() {
  const [guides, setGuides] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/guides").then((r) => setGuides(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="max-w-[1400px] mx-auto px-6 py-10">
      <div className="mb-10 flex items-end justify-between gap-4 flex-wrap">
        <div>
          <span className="tape-label">ASCENDING PROTOCOLS</span>
          <h1 className="font-display text-5xl md:text-7xl mt-3 leading-none">
            STEP-BY-STEP<br /><span className="text-[var(--primary)]">GUIDES.</span>
          </h1>
          <p className="text-[var(--text-muted)] mt-4 max-w-lg">
            Every protocol. Every move. Every cope eliminated.
          </p>
        </div>
        <BookOpen className="w-12 h-12 text-[var(--primary)]" />
      </div>

      {loading && <div className="font-mono text-xs text-[var(--text-muted)]">LOADING...</div>}

      <div className="grid grid-cols-12 gap-px bg-[var(--border)]">
        {guides.map((g) => (
          <Link
            key={g.id}
            to={`/guides/${g.id}`}
            data-testid={`guide-${g.id}`}
            className="col-span-12 md:col-span-6 lg:col-span-4 bg-[var(--bg)] p-6 group hover:bg-[var(--surface)] transition-colors flex flex-col"
          >
            <div className="flex items-start justify-between mb-6">
              <span
                className="text-[10px] font-mono uppercase tracking-widest border px-2 py-1"
                style={{ color: CAT_COLOR[g.category] || "white", borderColor: CAT_COLOR[g.category] || "white" }}
              >
                {g.category}
              </span>
              <ArrowUpRight className="w-4 h-4 text-[var(--text-muted)] group-hover:text-[var(--primary)] transition-colors" />
            </div>
            <h3 className="font-display text-2xl tracking-wide mb-3 group-hover:text-[var(--primary)] transition-colors">
              {g.title}
            </h3>
            <p className="text-sm text-[var(--text-muted)] flex-1">{g.summary}</p>
            <div className="mt-6 pt-4 border-t border-[var(--border)] flex justify-between text-[10px] font-mono uppercase tracking-widest text-[var(--text-muted)]">
              <span>{g.difficulty}</span>
              <span>{g.duration}</span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
